<template>
    <div v-if="offer && offer.lender">
        <div class="col lender-detail-container">
            <div class="lender-top">
                <div class="about-lender">
                    <h3>{{ $t('results.aboutLender.about') }} {{ offer.lender.name }}</h3>

                    <p>
                        {{ offer.lender.info }}
                    </p>
                </div>

                <div class="lender-facts" v-if="offer.lender.features.length">
                    <h3>
                        {{ $t('results.aboutLender.lenderFacts') }}
                    </h3>
                    <ul>
                        <li class="lender-fact-item" v-for="(feature, id) in offer.lender.features" :key="id">
                            <i class="far fa-check"></i>
                            <div class="lender-fact" v-html="feature"></div>
                        </li>
                    </ul>
                </div>
            </div>

            <div v-if="offer.lender.terms" class="terms">
                <h3 class="terms-heading">
                    {{ $t('results.aboutLender.termsDisclosures') }}
                </h3>

                <p class="terms-content" v-html="offer.lender.terms"></p>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    props: ['offer'],
}
</script>

<style lang="scss" scoped>
@import '~scss/mixins/rem';
@import '~scss/settings/responsive';

.lender-detail-container {
    padding-left: 0px;
    padding-right: 0px;

    .lender-top {
        display: flex;
        padding-left: 40px;
        padding-right: 40px;
        border-bottom: 1px solid #e5e5e5;
        padding-bottom: 50px;

        @media screen and (max-width: $bp-medium) {
            flex-direction: column;
            padding-left: 0px;
            padding-right: 0px;
            padding-bottom: 38px;
        }

        .about-lender {
            width: 60%;

            @media screen and (max-width: $bp-medium) {
                padding-top: 30px;
                width: 100%;
            }

            h3 {
                color: #242a2f;
                font-size: rem(30px);
                font-weight: 600;
            }

            p {
                color: #808080;
                font-size: rem(16px);
                margin: 0;
                font-weight: 300;
            }
        }

        .lender-facts {
            width: 40%;
            margin-top: 14px;
            margin-left: 30px;

            @media screen and (max-width: $bp-medium) {
                margin-left: 0px;
                margin-top: 30px;
                width: 100%;
            }

            h3,
            li {
                color: #242a2f;
                font-size: rem(18px);
                font-weight: 700;
            }

            li {
                font-size: rem(16px);

                &.lender-fact-item {
                    display: flex;
                    font-size: rem(16px);
                    font-weight: normal;

                    .fa-check {
                        color: #2ecc40;
                        margin-right: 10px;
                        margin-top: 5px;
                    }

                    .lender-fact {
                        color: #242a2f;
                    }
                }
            }
        }
    }

    .terms {
        padding-top: 30px;
        padding-left: 40px;
        padding-right: 40px;

        @media screen and (max-width: $bp-large) {
            padding-left: 0px;
            padding-right: 0px;
        }

        h3 {
            color: #242a2f;
            font-size: rem(18px);
            font-weight: 700;
        }

        p {
            color: #808080;
            font-size: rem(14px);
            margin: 0;
            font-weight: 300;
        }

        a {
            color: #007bff;
        }
    }
}
</style>
